/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Phone Information
 * @export
 * @interface TravelineBookingPersonPhoneDto
 */
export interface TravelineBookingPersonPhoneDto {
    /**
     * Phone number
     * @type {string}
     * @memberof TravelineBookingPersonPhoneDto
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the TravelineBookingPersonPhoneDto interface.
 */
export function instanceOfTravelineBookingPersonPhoneDto(value: object): value is TravelineBookingPersonPhoneDto {
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function TravelineBookingPersonPhoneDtoFromJSON(json: any): TravelineBookingPersonPhoneDto {
    return TravelineBookingPersonPhoneDtoFromJSONTyped(json, false);
}

export function TravelineBookingPersonPhoneDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPersonPhoneDto {
    if (json == null) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
    };
}

  export function TravelineBookingPersonPhoneDtoToJSON(json: any): TravelineBookingPersonPhoneDto {
      return TravelineBookingPersonPhoneDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPersonPhoneDtoToJSONTyped(value?: TravelineBookingPersonPhoneDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phoneNumber': value['phoneNumber'],
    };
}

